<claas-navigation
  [menuItems]="sideNavItems()"
  [(expanded)]="isExpanded"
  [applicationHasRouterOutlet]="true"
  [cssTopOffset]="cssTopOffset()">
  @if (!pendingOrgSwitch() && !pendingOrgRegistration() && !rehydratePending()) {
    <div class="h-full overflow-hidden">
      <div #toastsWrapper class="relative">
        <!-- do not && !hideRejectedOrgAlertBanner to prevent showing the pending org banner
        when the user closes the rejected org banner -->
        @if (orgIsRejected() && !internalOrg()) {
          @if (!hideRejectedOrgAlertBanner()) {
            <claas-alert-banner
              [inlineAlertBanner]="true"
              [bannerType]="'error'"
              [title]="'alert_banner.rejected_org.title' | translate"
              [description]="'alert_banner.rejected_org.description' | translate"
              [action]="'alert_banner.rejected_org.link' | translate"
              (actionClicked)="deleteOrg()"
              (closeButtonClicked)="closeRejectedOrgAlertBanner()"
              data-testid="rejected-org-banner">
            </claas-alert-banner>
          }
        } @else if (showOrgVerificationBanner()) {
          <claas-alert-banner
            [inlineAlertBanner]="true"
            [bannerType]="'info'"
            [title]="'alert_banner.unverified_org.title' | translate"
            [description]="'alert_banner.unverified_org.description' | translate"
            (closeButtonClicked)="closeUnverifiedOrgAlertBanner()"
            data-testid="unverified-org-banner"></claas-alert-banner>
        }
        @for (maintenanceToast of maintenanceToasts; track maintenanceToast) {
          <claas-alert-banner
            class="maintenance-alert-banner"
            [inlineAlertBanner]="true"
            [bannerType]="maintenanceToast.type"
            [title]="maintenanceToast.title"
            [description]="maintenanceToast.text"
            [inlineText]="true"
            (closeButtonClicked)="closeAlertWarning(maintenanceToast.id)"
            data-testid="maintenance-banner"></claas-alert-banner>
        }
      </div>
      <div id="main-scrollable-content" class="overflow-auto relative h-full" [style.height]="contentHeight$$()">
        <router-outlet></router-outlet>
      </div>
    </div>
  } @else {
    <div class="flex items-center justify-center">
      <app-spinner></app-spinner>
    </div>
  }
</claas-navigation>
